import { Tooltip } from "antd";
import React from "react";
import { BsFillInfoCircleFill } from "react-icons/bs";
import utils from "../../../../utils/utils";
import styles from "../../components.module.css";

function FieldHeader({ label, description }) {
  const labelText = utils.textAccordingToLanguage(label);
  const descriptionText = utils.textAccordingToLanguage(description);

  return label ? (
    <div style={{ display: "flex", justifyContent: "flex-start" }}>
      <label className={styles.form_control_label}>{labelText}</label>
      {description && (
        <Tooltip placement="right" title={descriptionText} zIndex={2000}>
          <span
            style={{
              alignSelf: "center",
              fontSize: "1rem",
              color: "#3a9ad9",
              cursor: "pointer",
              paddingTop: "5px",
            }}
          >
            <BsFillInfoCircleFill />
          </span>
        </Tooltip>
      )}
    </div>
  ) : (
    <></>
  );
}

export default FieldHeader;
